import React from 'react';
import { connect } from 'react-redux';
import {addElement} from "../../../actions/CreateSiteActions/createSiteActions";
import {ADD_PURPOSE, SET_PURPOSE_VALID} from "../../../actions/types";
import {purposeValidation} from "./Validation/PurposeValidation";
import {updateValidationStatus} from "../../../actions/ValidationActions/validateStep2Acitons";
import RequiredTextField from '../../formFields/RequiredTextField'
import InfoTooltip from '../../formFields/InfoTooltip';


class Purpose extends React.Component {

    componentDidMount() {
        if (this.props.purpose) {
            this.validate(this.props.purpose);
        }
    }

    validate = (value) => {
        let error = purposeValidation(value);
        this.props.updateValidationStatus(SET_PURPOSE_VALID, error)
    }

    onWriteEvent = (e, value) => {
        this.validate(value);
        this.props.addPurpose(ADD_PURPOSE, value);
    }

    render() {
        const toolTipContent = <span>
            Provide a short description of why you need to create a new site. <br/>
            <br/>
            Please note that your request for a new site will be sent to your line manager for approval.
            </span>
            
        const toolTipContentIATU = <span>
            Please make a brief description of the project.<br/>
            </span>
        return (
            <div className='business-reason-div'>
                <div className="item-title">
                {this.props.isIATU || this.props.isIAPCP ? "Project description" : "Site description"}
                    <InfoTooltip content={this.props.isIATU || this.props.isIAPCP ? toolTipContentIATU : toolTipContent} />
                </div>
                <label >
                    <RequiredTextField 
                        name="Purpose" 
                        onChange={this.onWriteEvent} 
                        value={this.props.purpose} 
                        validationResult={this.props.validationResult}
                        multiline
                        rows={14}
                    />
                </label>
            </div>
        );
    }
}

const mapActionToProp =
    {
        addPurpose : addElement,
        updateValidationStatus : updateValidationStatus
    }

const mapStateToProps  = state => ({
    purpose : state.newSite.Purpose,
    validationResult : state.step2Validation.PurposeValid,
    possibleWarning : state.wizard.nextStepRequested,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP
})

export default connect(mapStateToProps,mapActionToProp)(Purpose);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Purpose.js